import React, { useState } from 'react';
import './Navbar.css';
import SideNavbar from '../SideNavbar/SideNavbar';
import MenuIcon from '@mui/icons-material/Menu';

const Navbar = () => {
  const [sideNav,setSideNav] = useState(false);
  return (<>
    <div className='navbar fixed-top'>
      <div className="logo">
        <img src="images/conwave-logo.png" alt="" />
      </div>
      <div className="nav-items">
        <div className="nav-item">Home</div>
        <div className="nav-item">Services</div>
        <div className="nav-item">About Us</div>
        <div className="nav-item">Products</div>
        <div className="nav-item">Contact Us</div>
      </div>
    <div className="menu-btn" onClick={()=>setSideNav(!sideNav)}>
      <MenuIcon />
    </div>
    </div>
    {sideNav?<SideNavbar/>:""}
    </>
  )
}

export default Navbar
